import { render, staticRenderFns } from "./AccommodationRequestDisplay.vue?vue&type=template&id=473b1805&"
import script from "./AccommodationRequestDisplay.vue?vue&type=script&lang=js&"
export * from "./AccommodationRequestDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports